module.exports = __webpack_public_path__ + "static/media/financial-stress-and-thinking-large@3x.a46cf7cc.png";